import React from 'react'
import styled from 'styled-components'

const Footer = () => {
  return (
        <Wrapper>
            <div className="d-flex flex-column flex-md-row"> 
                <h5>&copy;{new Date().getFullYear()} <span> | Jessica Tacoen |</span></h5>
                <h5>Todos os direitos reservados</h5>
                <h5>| Imagens retiradas de <a href="https://www.freepik.com/" target="_blank" rel="noreferrer">freepik.com</a></h5>
            </div>
        </Wrapper>
    )
}
const Wrapper = styled.footer`
    position: fixed;
    bottom: 0;
    height: 3rem;
    width: 100vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: var(--website-main-color-dark-opacity);
    text-align: center;
    
    a {
        color: var(--clr-grey-9);
    }
    span {
        color: var(--clr-primary-5);
    }
    h5 {
        color: var(--clr-white);
        margin: 0.1rem;
        font-size: 0.9rem;
        font-weight: 400;
        text-transform: none;
        line-height: 1.25;
    }
    span {
        font-weight: 600;
    }
   
    @media only screen and (max-width: 765px) {
        height: 5rem;
    }
`

export default Footer
